import Aira1 from '../Aira Wynyard/Aira Wynyard (1).webp'
import Aira2 from '../Aira Wynyard/Aira Wynyard (2).webp'
import Aira3 from '../Aira Wynyard/Aira Wynyard (3).webp'
import Aira4 from '../Aira Wynyard/Aira Wynyard (4).webp'
import Aira5 from '../Aira Wynyard/Aira Wynyard (5).webp'
import Aira6 from '../Aira Wynyard/Aira Wynyard (6).webp'
import Aira7 from '../Aira Wynyard/Aira Wynyard (7).webp'
import Aira8 from '../Aira Wynyard/Aira Wynyard (8).webp'



const Airaimages =[
Aira1,Aira2,Aira3,Aira4,Aira5,Aira6,Aira7,Aira8
]

export default Airaimages;